<template>
  <div>
    <spinner v-if="loading" size="200" />

    <v-tabs v-else grow>
      <v-tab v-for="adminCat of adminCategories" :key="adminCat.id"
        >{{ adminCat.name }}
      </v-tab>

      <v-tab-item v-for="adminCat of adminCategories" :key="adminCat.id">
        <admin-document-category
          :adminCat="adminCat"
          :categories="categories"
          :documents-props="sortedDocuments[adminCat.id]"
          :clients="clients"
          class="mt-2"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { apiCallRebuild, notifyErrorFetchRaw } from "@/helper";
import { API_ROUTES } from "@/Services/api.common.service";
import { ADMIN_CATEGORIES, CATEGORIES } from "@/setup.const";
import AdminDocumentCategory from "@/views/AdminDocument/AdminDocumentCategoryForAll";

export default {
  props: ["routerCategories"],
  components: {
    AdminDocumentCategory,
  },
  data() {
    return {
      loading: true,
      clients: [],
      sortedDocuments: {},
      categories: CATEGORIES,
      adminCategories: ADMIN_CATEGORIES,
    };
  },

  watch: { $route: "fetchData" },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      const notifyError = notifyErrorFetchRaw.bind(this);

      try {
        const resApi = await apiCallRebuild(API_ROUTES.adminDocuments);
        const documents = resApi?.documents?.documents || [];

        //        replace client id by their name
        this.clients = resApi?.clients?.clients || [];
        documents.forEach((x) => {
          const getName = (id) => this.clients.find((e) => e?.id === id)?.name;
          x.searchClient = x.clients.map((id) => getName(id));
        });

        const sortedDocuments = {};

        const filterDocumentByAdminCategories = (adminCategory) =>
          documents.filter((el) => el.adminCategory === adminCategory);

        this.adminCategories.forEach(({ id }) => {
          const dateCmp = (a, b) => {
            return new Date(b.date) - new Date(a.date);
          };

          sortedDocuments[id] =
            filterDocumentByAdminCategories(id).sort(dateCmp);
        });

        this.sortedDocuments = sortedDocuments;

        this.loading = false;
      } catch (e) {
        console.error(e);
        notifyError();
      }
    },
  },
};
</script>
